import {
  AlignLeft,
  Calendar,
  ChevronDown,
  Clock,
  FileText,
  Hash,
  Heading,
  Image,
  Link,
  List,
  Mail,
  MapPin,
  Phone,
  Star,
  Type,
  Upload,
  User,
  Users,
} from 'lucide-react';

// ─── Field type icon mapping ───────────────────────────────────────────────────
const FIELD_TYPE_ICONS = {
  name: { icon: Type, bg: 'bg-interactive-light', color: 'text-interactive' },
  text: { icon: Type, bg: 'bg-interactive-light', color: 'text-interactive' },
  'long-text': { icon: AlignLeft, bg: 'bg-indigo-100', color: 'text-indigo-600' },
  long_text: { icon: AlignLeft, bg: 'bg-indigo-100', color: 'text-indigo-600' },
  email: { icon: Mail, bg: 'bg-interactive-light', color: 'text-interactive' },
  phone: { icon: Phone, bg: 'bg-green-100', color: 'text-green-600' },
  numbers: { icon: Hash, bg: 'bg-orange-100', color: 'text-orange-600' },
  numeric: { icon: Hash, bg: 'bg-orange-100', color: 'text-orange-600' },
  date: { icon: Calendar, bg: 'bg-rose-100', color: 'text-rose-600' },
  timeline: { icon: Clock, bg: 'bg-rose-100', color: 'text-rose-600' },
  status: { icon: List, bg: 'bg-green-100', color: 'text-green-600' },
  color: { icon: List, bg: 'bg-green-100', color: 'text-green-600' },
  dropdown: { icon: ChevronDown, bg: 'bg-cyan-100', color: 'text-cyan-600' },
  file: { icon: Upload, bg: 'bg-gray-100', color: 'text-gray-600' },
  link: { icon: Link, bg: 'bg-sky-100', color: 'text-sky-600' },
  rating: { icon: Star, bg: 'bg-yellow-100', color: 'text-yellow-600' },
  location: { icon: MapPin, bg: 'bg-red-100', color: 'text-red-600' },
  people: { icon: Users, bg: 'bg-violet-100', color: 'text-violet-600' },
  person: { icon: User, bg: 'bg-violet-100', color: 'text-violet-600' },
  mirror: { icon: FileText, bg: 'bg-slate-100', color: 'text-slate-600' },
  formula: { icon: FileText, bg: 'bg-slate-100', color: 'text-slate-600' },
  board_relation: { icon: FileText, bg: 'bg-slate-100', color: 'text-slate-600' },
  // section-type cards
  heading: { icon: Heading, bg: 'bg-gray-100', color: 'text-gray-600' },
  image: { icon: Image, bg: 'bg-gray-100', color: 'text-gray-600' },
};

const DEFAULT_ICON = { icon: FileText, bg: 'bg-gray-100', color: 'text-gray-600' };

const FieldTypeIcon = ({ type, size = 'sm' }) => {
  const cfg = FIELD_TYPE_ICONS[type] || DEFAULT_ICON;
  const Icon = cfg.icon;
  // bare: no background, just the icon in neutral secondary color
  if (size === 'bare') {
    return <Icon className="w-3.5 h-3.5 flex-shrink-0" style={{ color: 'var(--color-text-secondary)' }} />;
  }
  const dim = size === 'sm' ? 'w-7 h-7' : 'w-8 h-8';
  const iconDim = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';
  return (
    <div className={`flex items-center justify-center ${dim} rounded-md ${cfg.bg} flex-shrink-0`}>
      <Icon className={`${iconDim} ${cfg.color}`} />
    </div>
  );
};

export default FieldTypeIcon;
